module.exports = __webpack_public_path__ + "img/black_lock.0ff6f6a3.gif";